import { createFiltersActions } from '../utils';

export const ACTIONS_PREFIX = 'LICENSES';

export const {
    updateFilters,
    applyFilters,
    resetApplyFilters,
    resetApplyFiltersSilently,
    rebuildApplyFiltersSilently
} = createFiltersActions(ACTIONS_PREFIX);
